import { Currency, Price } from 'in-time-core';
import { Locale } from '../models/locale';

export class NativePriceFormatter {
  constructor(
    private readonly locale: Locale,
  ) {}

  format(price: Price): string {
    const value = price.asDouble;
    const hasDecimals = price.currency != Currency.HUF && !Number.isSafeInteger(value);

    const result = Intl.NumberFormat(
      this.locale.name,
      {
        style: 'currency',
        currency: price.currency,
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: hasDecimals ? 2 : 0,
      }
    ).format(value);

    if(this.locale.name === 'hu-HU') {
      return result.replace('lei', 'lej');
    }

    return result;
  }

  formatRange(from: Price, to: Price): string {
    const formattedFrom = this.format(from);
    const formattedTo = this.format(to);

    return `${formattedFrom} - ${formattedTo}`;
  }
}
